import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import ContentBuilder from '~/components/Layout/Builders/ContentBuilder';
import { ArticleContext } from '~/contexts/ArticleContext';
import { AppDataContext } from '~/contexts/AppDataContext';
import { maybeGetSlide } from '~/utilities/maybeGetSlide';
import { cva } from 'class-variance-authority';
import { getCSSColorChildLinks } from '~/utilities/getCSS';

const cssArticleLinks = cva('article-content', {
  variants: {
    color: getCSSColorChildLinks(),
  },
});

export default component$((): JSX.Element => {
  const { payloadToSSR, appState, themeComponents } =
    useContext(AppDataContext);
  const article = useContext(ArticleContext);
  const slideshow = payloadToSSR.pageContent.slideshow ?? article.slideshow;

  return (
    <div
      class={cssArticleLinks({
        color: themeComponents.articleBlock.paragraphLinkColor.value,
      })}
    >
      <ContentBuilder
        items={maybeGetSlide(article, slideshow, appState.currentSlide)}
      />
    </div>
  );
});
